<script>
export default {
  name: "m-audio-skeleton",
  props: {
    skeletonBars: {
      type: Number,
      default: 55
    }
  },
  data() {
    return {
      skeletonPhase: 0,         // текущая фаза волны
      skeletonIntervalId: null, // для остановки анимации
    }
  },
  methods: {
    startSkeletonWave() {
      this.skeletonIntervalId = setInterval(() => {
        this.skeletonPhase -= 0.1
      }, 100)
    },
    getSkeletonBarStyle(n) {
      const amplitude = 30
      const baseHeight = 40
      const waveLength = 10

      const radians = (n / waveLength + this.skeletonPhase) * Math.PI
      const height = baseHeight + Math.sin(radians) * amplitude

      return {
        height: `${height}px`,
        transition: 'height 0.2s linear',
      }
    },
  },
  mounted() {
    this.startSkeletonWave()
  },
  beforeDestroy() {
    clearInterval(this.skeletonIntervalId)
  },
}
</script>

<template>
  <div class="waveform-skeleton">
    <div
        v-for="n in skeletonBars"
        :key="n"
        :style="getSkeletonBarStyle(n)"
        class="skeleton-bar"
    ></div>
  </div>
</template>

<style scoped lang="scss">
.waveform-skeleton {
  display: flex;
  align-items: center;
  height: auto;
  width: 100%;
  gap: 4px;
  overflow: hidden;
}

.skeleton-bar {
  width: 3px;
  background-color: #d3d6db;
  border-radius: 2px;
  animation: pulse 3s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
    transform: scaleY(1);
  }
  50% {
    opacity: 1;
    transform: scaleY(0.5);
  }
}
</style>